import { render, staticRenderFns } from "./KalendarEventsSection.vue?vue&type=template&id=4dad8172"
import script from "./KalendarEventsSection.vue?vue&type=script&lang=js"
export * from "./KalendarEventsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports